import type React from 'react'

export const SliteAgentIcon = ({
  size = 40,
  style = {},
  ...props
}: {
  size?: number
  style?: React.CSSProperties
} & React.ComponentProps<'svg'>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    style={style}
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <g stroke="currentColor" clipPath="url(#clip0_2258_12065)">
      <path
        strokeLinecap="round"
        strokeWidth="4.5"
        d="M20.196 41.103c-7.22 1.15-13.584-.72-16.331-5.478C-.277 28.451 5.38 17.43 16.5 11.01s23.493-5.81 27.635 1.365c1.91 3.31 1.736 7.437-.097 11.554"
      ></path>
      <path
        fill="currentColor"
        strokeWidth="3"
        d="M31.078 38.939a1.5 1.5 0 1 1-1.408-2.65 1.5 1.5 0 0 1 1.408 2.65ZM39.437 32.874a1.5 1.5 0 1 1-2.096-2.146 1.5 1.5 0 0 1 2.096 2.146Z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_2258_12065">
        <path fill="#fff" d="M0 0h48v48H0z"></path>
      </clipPath>
    </defs>
  </svg>
)
